export const ASPECT_RATIOS = ['1:1', '2:3', '3:2', '9:16', '16:9']

export const VARIATION_COUNTS = [1, 2, 3, 4]

export const DEFAULT_SETTINGS = {
  aspectRatio: ASPECT_RATIOS[0],
  variations: VARIATION_COUNTS[0],
}
